import React from 'react';
import { Route, Switch, useRouteMatch } from "react-router-dom";

import MortgageDetailsTable from '../container/Mra_Details/MortgageDetailsTable';
import Navigation from "../container/Navigation";
import * as CONST from "../app/constants"
import BrokerDetailsTable from '../container/Mra_Details/BrokerDetailsTable';

export const MortgageDetailsApp = (props) => {
    let { path } = useRouteMatch();
    return (
        <>
            <Navigation {...props} applicationType={CONST.APPLICATION_TYPE_MORTGAGE_DETAILS} />
            <Switch>
                <Route
                    path={`${path}${CONST.ROUTE_PATH.MRA_DETAILS_LIST}`}
                    component={MortgageDetailsTable}
                    exact
                />
                <Route
                    path={`${path}${CONST.ROUTE_PATH.BROKER_DETAILS_LIST}`}
                    component={BrokerDetailsTable}
                    exact
                />
            </Switch>
        </>
    )
}
